import { connect, MapDispatchToProps, MapStateToProps, MergeProps } from "react-redux";

import { ButtonBackgroundColor, ComponentSize, TextButton, TextButtonProps } from "@multiweb/reactComponents";
import { getPrimaryText, getSecondaryText } from "@multiweb/reactCore/i18n";
import { TAB_INDEX_FOCUSABLE_ONLY } from "@multiweb/reactUtils/constants";
import { IAppState, NoneOwnProps, TextAlign } from "@multiweb/types/react";
import { createSetActiveGroupNotificationsAsReadedAction } from "../../actions";
import { LOC_KEY_SET_ALL_NOTIFICATION_AS_READ } from "../../locKeys";
import { isFocused, SET_GROUP_NOTIFICATIONS_AS_READ_BUTTON_FOCUSABLE_ID } from "../../navigation";

type StateProps = Pick<TextButtonProps, "isFocused" | "text" | "title">;

const mapStateToProps: MapStateToProps<StateProps, NoneOwnProps, IAppState> = (state) => ({
    isFocused: isFocused(state, SET_GROUP_NOTIFICATIONS_AS_READ_BUTTON_FOCUSABLE_ID),
    text: getPrimaryText(state, LOC_KEY_SET_ALL_NOTIFICATION_AS_READ),
    title: getSecondaryText(state, LOC_KEY_SET_ALL_NOTIFICATION_AS_READ),
});

type DispatchProps = Pick<TextButtonProps, "onClick">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, NoneOwnProps> = {
    onClick: createSetActiveGroupNotificationsAsReadedAction,
};

const mergeProps: MergeProps<StateProps, DispatchProps, NoneOwnProps, TextButtonProps> = ({ isFocused, text, title }, { onClick }) => ({
    backgroundColor: ButtonBackgroundColor.transparent,
    size: ComponentSize.large,
    tabIndex: TAB_INDEX_FOCUSABLE_ONLY,
    text,
    title,
    isFocused,
    onClick,
    width: "100%",
    textAlign: TextAlign.center,
});

/**
 * Button pro označení všech notifikací jako přečtené.
 */
export const SetAllNotificationAsReadButton = connect(mapStateToProps, mapDispatchToProps, mergeProps)(TextButton);
